import {
  fetchAll,
  fetchFiltered,
  addCostMaterialTransportation,
  show,
  edit,
  generateReport,
  deleteCost
} from "@/api/costmaterialtransportation";

const state = {
  all: [],
  isLoading: false,
  costMaterialTransportation: null
};

const actions = {
  cleanState({ commit }) {
    commit("cleanState");
  },

  async fetchById({ dispatch, commit }, id) {
    try {
      const costMaterialTransportation = await show(id);

      commit("setCostMaterialTransportation", costMaterialTransportation);
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    }
  },

  async fetchAll({ dispatch, commit }) {
    try {
      const costMaterialTransportations = await fetchAll();

      commit("setAll", costMaterialTransportations);
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    }
  },

  async fetchFiltered({ dispatch, commit }, queriesParams) {
    try {
      const costMaterialTransportations = await fetchFiltered(queriesParams);

      commit("setAll", costMaterialTransportations);
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    }
  },

  async create({ dispatch, commit }, data) {
    try {
      dispatch("overlay/show", true, { root: true });

      commit("setLoading", true);

      await addCostMaterialTransportation(data);

      return true;
    } catch (e) {
      dispatch("notify/error", e, { root: true });

      return false;
    } finally {
      commit("setLoading", false);

      dispatch("overlay/show", false, { root: true });
    }
  },

  async edit({ dispatch, commit }, { id, data }) {
    try {
      dispatch("overlay/show", true, { root: true });

      commit("setLoading", true);

      await edit(id, data);

      return true;
    } catch (e) {
      dispatch("notify/error", e, { root: true });

      return false;
    } finally {
      commit("setLoading", false);

      dispatch("overlay/show", false, { root: true });
    }
  },

  async generateReport({ dispatch }, queriesParams) {
    try {
      const reportStructure = await generateReport(queriesParams);

      return reportStructure
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    }
  },

  async deleteCost({ dispatch }, id) {
    try {
      dispatch("overlay/show", true, { root: true });

      await deleteCost(id);

      return true;
    } catch (e) {
      dispatch("notify/error", e, { root: true });

      return false;
    } finally {
      dispatch("overlay/show", false, { root: true });
    }
  },
};

const mutations = {
  cleanState(state) {
    state.all = [];
    state.isLoading = false;
    state.costMaterialTransportation = null;
    state.reportStructure = null
  },

  setAll(state, costMaterialTransportations) {
    state.all = costMaterialTransportations;
  },

  setCostMaterialTransportation(state, costMaterialTransportation) {
    state.costMaterialTransportation = costMaterialTransportation;
  },

  setLoading(state, isLoading) {
    state.isLoading = isLoading;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
